export type FrisbiiErrorCode = 'account_exists' | 'payment_failed' | 'unknown';

export class FrisbiiError extends Error {
  code: FrisbiiErrorCode;

  constructor(code: FrisbiiErrorCode, originalError?: Error) {
    super();
    this.code = code;
  }
}
